export const USER_LOAD = 'USER_LOAD';
export const USER_CLEAR = 'USER_CLEAR';
export const USER_UPDATE = 'USER_UPDATE';
export const USER_SET_INTERVAL_ID = 'USER_SET_INTERVAL_ID';
export const USER_CLEAR_INTERVAL_ID = 'USER_CLEAR_INTERVAL_ID';

// deprecated
export const LOAD = 'LOAD';
export const UPDATE = 'UPDATE';
export const CLEAR = 'CLEAR';

export const SET_USER = 'SET_USER';
